// Instructor-only orchestration tool for Tandem. Calls queue a halt after the assistant tool batch
// so `TandemManager` can advance to the Engineer lane without recursive inference.

import { BaseAITool } from "../../../../base/BaseAITool.js";

const INSTRUCTOR_ONLY = Object.freeze(["instructor"]);

export class TandemPromptEngineerTool extends BaseAITool {
  constructor() {
    super();
    this.toolId = "tandem-prompt-engineer";
    this.definition = {
      type: "function",
      function: {
        name: "tandem-prompt-engineer",
        description:
          "End this instructor turn by delegating to the Engineer. After this tool runs, " +
          "your instructions are forwarded as a user message on the Engineer track. " +
          "You must call this when you are ready for implementation or analysis work there; " +
          "do not assume the Engineer runs until you call this tool.",
        parameters: {
          type: "object",
          properties: {
            instructionsForEngineer: {
              type: "string",
              description:
                "Instructions the Engineer should follow (markdown allowed). Shown as a user message prefixed [Instructor].",
            },
          },
          required: ["instructionsForEngineer"],
        },
      },
    };
  }

  get tandemLaneIds() {
    return INSTRUCTOR_ONLY;
  }

  async execute({ instructionsForEngineer } = {}) {
    this.queueHaltInferenceAfterAssistantToolBatch();
    const text =
      typeof instructionsForEngineer === "string" ? instructionsForEngineer.trim() : "";
    return {
      ok: true,
      handedOffToEngineer: true,
      charCount: text.length,
    };
  }
}
